
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface AssessmentLoaderProps {
  isLoading: boolean;
  message?: string;
}

export const AssessmentLoader = React.memo(({ isLoading, message = "Loading Assessment" }: AssessmentLoaderProps) => {
  if (!isLoading) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <h3 className="text-lg font-semibold">{message}</h3>
            <p className="text-gray-600">Please wait...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
});

AssessmentLoader.displayName = 'AssessmentLoader';
